import { useSourceSidebarItems } from '_/components/Sources/useSourceSidebarItems';
import { useSidebar, CONTEXT_DEPTH } from '_/contexts/LayoutContext';
import { SourceProvider, useSourceContext } from '_/contexts/SourceContext';
import React, { ReactNode, useEffect } from 'react';

interface SourceSectionProps {
  children: ReactNode;
}

/**
 * Sidebar manager that consumes SourceContext
 * Separated from provider to avoid circular dependency
 */
function SourceSidebarManager({ children }: SourceSectionProps) {
  const { selectedSourceSlug } = useSourceContext();
  const { setSidebarItems, registerContext, unregisterContext } = useSidebar();
  const sidebarItems = useSourceSidebarItems();

  useEffect(() => {
    registerContext(CONTEXT_DEPTH.SOURCE);
    return () => {
      unregisterContext(CONTEXT_DEPTH.SOURCE);
    };
  }, [registerContext, unregisterContext]);

  useEffect(() => {
    if (selectedSourceSlug && selectedSourceSlug !== '_new' && sidebarItems.length > 0) {
      setSidebarItems(sidebarItems, CONTEXT_DEPTH.SOURCE);
    }
  }, [setSidebarItems, sidebarItems, selectedSourceSlug]);

  return <>{children}</>;
}

/**
 * SourceSection - Wrapper for source-level pages
 * Combines provider and sidebar manager
 */
function SourceSection({ children }: SourceSectionProps) {
  return (
    <SourceProvider>
      <SourceSidebarManager>{children}</SourceSidebarManager>
    </SourceProvider>
  );
}

export default SourceSection;
